import DocumentsData from '../section/DocumentsData.js';
import NavMenu from '../section/LoggedInNav.js';
import SITELINKS from '../section/Footer.js';
import Banner from '../section/Title.js';
import { Authenticator } from '@aws-amplify/ui-react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import UserFilesList from '../components/UserFilesList';

export const Documents = () => {
    return (
      <div className='App'>
        <div className='hidden'>
          <Banner/>
        </div>
        <NavMenu/> 
        <Authenticator className='login_container container' loginMechanisms={['email']} hideSignUp>
          <Container className='App padding-top'>
            <Row>
              <Col xs={12}>
                <h3 className='text-center emphTitle'>MY DOCUMENTS</h3>
                <p className=' text-center'>Access important files, forms, and guidelines in our centralized document repository.</p>
                <hr></hr>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col xs={12}>
                <UserFilesList />
              </Col>
            </Row>
          </Container>  
        </Authenticator>
        <SITELINKS/> 
      </div>
    );
  };